const SkeletonProductCard = () => (
  <div className="flex-[0_0_76%] mobile:flex-[0_0_calc(50%-6px)] desktop:flex-[0_0_calc(33.333%-8px)] xl:flex-[0_0_269px] min-w-0 pl-3 last:mr-4 desktop:last:mr-0">
    <div className="flex flex-col rounded-[8px] overflow-hidden bg-white">
      <div className="aspect-square w-full bg-gray-50" />
      <div className="flex flex-col gap-2 px-3 py-4">
        <div className="h-4 w-3/4 bg-gray-100 rounded" />
        <div className="h-4 w-1/3 bg-gray-100 rounded mt-auto" />
      </div>
    </div>
  </div>
);

export default function SkeletonProductSlider() {
  return (
    <section className="bg-surface-neutral-subtle overflow-x-clip animate-pulse">
      <div className="content-container py-8 desktop:py-10 flex flex-col gap-6">
        <div className="flex flex-col gap-5">
          <div className="flex flex-col gap-3">
            <div className="h-10 w-2/3 bg-gray-50 rounded" />
            <div className="h-4 w-40 bg-gray-50 rounded" />
          </div>
        </div>
        <div className="flex -ml-3">
          {Array.from({ length: 4 }).map((_, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton, index is stable
            <SkeletonProductCard key={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
